import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';

import SolutionCreate from './create';
import SolutionList from './list';
import SolutionShow from './show';
import SolutionEdit from './edit';

export default {
    create: SolutionCreate,
    list: SolutionList,
    show: SolutionShow,
    edit: SolutionEdit,
    icon: SentimentVerySatisfiedIcon
};